import clsx from "clsx";
import React from "react";
import ReactHtmlParser from "react-html-parser";

const FormHeader = ({ heading, subHeading, size = "xl", centered = true }) => {
  return (
    <div
      className={clsx({
        "space-y-1": size === "xl",
        "space-y-0": size === "lg",
      })}
    >
      <h1
        className={clsx("", {
          "text-center": centered,
          "heading-xl": size === "xl",
          "heading-xs": size === "lg",
        })}
      >
        {heading}
      </h1>
      <div
        className={clsx(
          "[&>a]:underline-offset-4 text-lg text-gray-400 [&>a]:text-gray-500 [&>a]:underline [&>a]:decoration-gray-300 [&>a]:decoration-1",
          {
            "text-center": centered,
          },
        )}
      >
        {ReactHtmlParser(subHeading)}
      </div>
    </div>
  );
};

export default FormHeader;
